module.exports = __webpack_public_path__ + "static/media/ic-totally-online.3e6a59a8.svg";